var render = function render(){
  var _vm$filter$inputType$, _vm$filter$inputType$2, _vm$filter$inputType$3, _vm$filter$inputType$4, _vm$filter$inputType$5, _vm$filter$inputType$6, _vm$filter$inputType$7, _vm$filter$inputType$8, _vm$filter$inputType$9, _vm$filter$inputType$10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "inputContainer",
    class: {
      'inline-input': _vm.isInline
    },
    attrs: {
      "data-filter-identifier": _vm.filter.identifier
    }
  }, [(_vm$filter$inputType$ = (_vm$filter$inputType$2 = _vm.filter.inputType.config).readonly) !== null && _vm$filter$inputType$ !== void 0 && _vm$filter$inputType$.call(_vm$filter$inputType$2, _vm.filter, _vm.value) ? _c('div', [_c('b-input', {
    attrs: {
      "type": "text",
      "readonly": "",
      "value": _vm.internalValue
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputText ? _c('div', [_c('b-input', {
    class: _vm.inputCssClasses,
    attrs: {
      "type": "text",
      "size": "sm",
      "placeholder": _vm.actualPlaceholder,
      "disabled": _vm.isInputDisabled,
      "autocomplete": "off"
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputSelectOneWithSearch || _vm.filter.inputType instanceof _vm.FrontendFilterInputBooleanSelect ? _c('div', [_c('ModelSelect', {
    staticClass: "select-one-with-search",
    class: _vm.inputCssClasses,
    attrs: {
      "options": _vm.optionsForFrontendFilterInputSelectOneWithSearch,
      "is-disabled": _vm.isInputDisabled,
      "placeholder": _vm.actualPlaceholder
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputSelectMultipleWithSearch ? _c('div', [_c('MultiSelect', {
    class: _vm.inputCssClasses,
    attrs: {
      "options": _vm.optionsForFrontendFilterInputSelectOneWithSearch,
      "option-label": "text",
      "option-value": "value",
      "placeholder": _vm.actualPlaceholder,
      "show-toggle-all": false,
      "disabled": _vm.isInputDisabled
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputSelectOne ? _c('div', [_c('b-select', {
    class: _vm.inputCssClasses,
    attrs: {
      "size": "sm",
      "options": _vm.options,
      "value-field": "value",
      "html-field": "text",
      "placeholder": _vm.actualPlaceholder,
      "disabled": _vm.isInputDisabled
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputNumber ? _c('div', [_c('b-input', {
    class: _vm.inputCssClasses,
    attrs: {
      "type": "number",
      "size": "sm",
      "min": (_vm$filter$inputType$3 = (_vm$filter$inputType$4 = _vm.filter.inputType.config).min) === null || _vm$filter$inputType$3 === void 0 ? void 0 : _vm$filter$inputType$3.call(_vm$filter$inputType$4, _vm.value),
      "max": (_vm$filter$inputType$5 = (_vm$filter$inputType$6 = _vm.filter.inputType.config).max) === null || _vm$filter$inputType$5 === void 0 ? void 0 : _vm$filter$inputType$5.call(_vm$filter$inputType$6, _vm.value),
      "placeholder": _vm.actualPlaceholder,
      "disabled": _vm.isInputDisabled,
      "autocomplete": "off"
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputDate ? _c('div', [_c('b-input', {
    class: _vm.inputCssClasses,
    attrs: {
      "type": "date",
      "size": "sm",
      "min": (_vm$filter$inputType$7 = (_vm$filter$inputType$8 = _vm.filter.inputType.config).min) === null || _vm$filter$inputType$7 === void 0 ? void 0 : _vm$filter$inputType$7.call(_vm$filter$inputType$8, _vm.value),
      "max": (_vm$filter$inputType$9 = (_vm$filter$inputType$10 = _vm.filter.inputType.config).max) === null || _vm$filter$inputType$9 === void 0 ? void 0 : _vm$filter$inputType$9.call(_vm$filter$inputType$10, _vm.value),
      "disabled": _vm.isInputDisabled
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _vm.filter.inputType instanceof _vm.FrontendFilterInputMultiple ? _c('div', [_c('Chips', {
    staticClass: "frontend-filter-input-multiple form-control-sm p-0",
    class: _vm.inputCssClasses,
    attrs: {
      "disabled": _vm.isInputDisabled,
      "placeholder": _vm.actualPlaceholder,
      "addOnBlur": ""
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  })], 1) : _c('div', [_c('i', {
    staticClass: "text-danger"
  }, [_vm._v("onbekend input type")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }